import { DataRetentionPeriod } from "@/types/workspaces";

export const DEFAULT_RETENTION_PERIOD: DataRetentionPeriod = "forever";

export const RETENTION_PERIOD_PRESETS: {
  label: string;
  value: DataRetentionPeriod;
  id: string;
}[] = [
  { label: "14 days", value: "14_days", id: "retention-14-days" },
  { label: "30 days", value: "30_days", id: "retention-30-days" },
  { label: "90 days", value: "90_days", id: "retention-90-days" },
  { label: "Forever", value: "forever", id: "retention-forever" },
];
